export const ED_COM = {
    name: 'Ed-com',
    value: 'ED_COM',
};
export const PERSON_DATABASE = {
    name: 'People Records',
    value: 'PERSON_DATABASE',
};
export const LMS = {
    name: 'LMS',
    value: 'LMS',
};
const Basic = [ED_COM, PERSON_DATABASE];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
export default {
    Basic,
    BasicByValue,
};
